import { render, staticRenderFns } from "./WidgetOpportunities.vue?vue&type=template&id=7580c240&scoped=true"
import script from "./WidgetOpportunities.vue?vue&type=script&lang=js"
export * from "./WidgetOpportunities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7580c240",
  null
  
)

export default component.exports